// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRadiusSettingOutlinedSvg from "@fishx/icons-svg/es/asn/PRadiusSettingOutlined";
import FishxIcon from '../components/FishxIcon';

var PRadiusSettingOutlined = function PRadiusSettingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRadiusSettingOutlinedSvg
  }));
};

PRadiusSettingOutlined.displayName = 'PRadiusSettingOutlined';
export default React.forwardRef(PRadiusSettingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRadiusSettingOutlined.js
// module id = 3578
// module chunks = 0